import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Polygon,
          {
            points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "9", y1: "3", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "15", y1: "6", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Map";
const Map = memo(themed(Icon));
export {
  Map
};
//# sourceMappingURL=map.js.map
